import {ADataGridColors, ADataGridFilter, PagedSearchParams} from "@atiautomacao/ati-ui-library";
import axios, {AxiosRequestConfig} from "axios";
import {INHIBITED_STATUS_COLOR} from "./InhibitionVisual";

export type TotalizerType =  "alarms_sound" | "not_acknowledged" | "power_station_no_communication"  | "equipment_no_communication" | "equipments_alarmed" | "active" | "active_critical" | "none";
export const ALARM_SEVERITY = {
    CRITICAL: 1,
    HIGH: 2,
    MEDIUM: 3,
    LOW: 4,
    NOT_APPLICABLE: 5,
    URGENT: 6,
};

export const INHIBITED_ALARM_COLOR = INHIBITED_STATUS_COLOR;

type AlarmInhibitionState = {
    teleObjectInhibited?: boolean | null;
    severityName?: string | null;
};

export const isTeleObjectAlarmInhibited = (alarm: unknown): boolean => {
    if (typeof alarm !== 'object' || alarm === null) {
        return false;
    }
    return (alarm as AlarmInhibitionState).teleObjectInhibited === true;
};

export const getAlarmDisplayLabel = (alarm: AlarmInhibitionState): string => {
    const severityName = alarm.severityName?.trim();
    if (!isTeleObjectAlarmInhibited(alarm)) {
        return severityName || '';
    }
    return severityName ? `Inibido · ${severityName}` : 'Inibido';
};

export const checkGroupingType = (alarm: any): Array<ADataGridFilter> => {
    if (alarm.equipmentId !== null && alarm.teleObjectId == null) {
        console.log("Equipment off-air");
        return [
            {name: 'equipmentId', condition: 'equals', value: alarm.equipmentId?.toString(), sort: 'none'},
            {name: 'teleObjectId', condition: 'equals', value: "null", sort: 'none'},
            {name: 'severityId', condition: 'equals', value: alarm.severityId?.toString(), sort: 'none'},
        ];
    }else if (alarm.equipmentId == null) {
        console.log("Power station off-air");
        return [
            {name: 'equipmentId', condition: 'equals', value: "null", sort: 'none'},
            {name: 'powerStationId', condition: 'equals', value: alarm.powerStationId?.toString(), sort: 'none'},
            {name: 'severityId', condition: 'equals', value: alarm.severityId?.toString(), sort: 'none'},
        ];
    }else if ( alarm.teleObjectId !== null && alarm.description && alarm.description.includes('Valor')) {
        console.log("TeleMeasure")
        return [
            {name: 'teleObjectId', condition: 'equals', value: alarm.teleObjectId?.toString(), sort: 'none'},
            {name: 'equipmentId', condition: 'equals', value: alarm.equipmentId?.toString(), sort: 'none'},
            {name: 'powerStationId', condition: 'equals', value: alarm.powerStationId?.toString(), sort: 'none'},
            {name: 'severityId', condition: 'equals', value: alarm.severityId?.toString(), sort: 'none'},
            {name: 'description', condition: 'contains', value: 'Valor', sort: 'none'},
        ];
    } else{
        console.log("TeleObject");
        return [
            {name: 'teleObjectId', condition: 'equals', value: alarm.teleObjectId?.toString(), sort: 'none'},
            {name: 'equipmentId', condition: 'equals', value: alarm.equipmentId?.toString(), sort: 'none'},
            {name: 'powerStationId', condition: 'equals', value: alarm.powerStationId?.toString(), sort: 'none'},
            {name: 'severityId', condition: 'equals', value: alarm.severityId?.toString(), sort: 'none'},
        ];
    }
};

export async function alarmSearchGroup(params: PagedSearchParams) {
    const config: AxiosRequestConfig = {
        url: 'api/alarm/grouping/search',
        params: params.toURLSearchParams(),
        method: 'GET',
    };
    return new Promise((resolve, reject) => {
        axios(config)
            .then((response) => {
                resolve(response.data.data.length > 1);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

const checkSeverityId = (data:any, number:number): boolean => {
    return typeof data === 'object' && data !== null && typeof data.severityId === 'number' && data.severityId === number
}

export const handleOnColor = (data: any, columnItem: any, theme?:any): ADataGridColors => {
    const severityColor = (data as { severityColor: string }).severityColor
    const colorTheme = theme?.palette?.mode === 'light' ? '#000000' : '#fff'
    let dataGridColors: ADataGridColors = {
        color: theme ? colorTheme : '#000000',
        backgroundColor: '',
    }
    if (isTeleObjectAlarmInhibited(data)) {
        return {
            color: '#FFFFFF',
            backgroundColor: INHIBITED_ALARM_COLOR,
        };
    }
    if(checkSeverityId(data, ALARM_SEVERITY.NOT_APPLICABLE)){
        return dataGridColors
    }
    if(data?.clearDate === "" || data?.clearDate === null) {
        dataGridColors = {
            color: checkSeverityId(data, ALARM_SEVERITY.URGENT) ? '#FFFFFF' : '#000000',
            backgroundColor: '#' + severityColor
        }
        return dataGridColors
    }

    if(typeof columnItem.name === 'string' && columnItem.name.toLowerCase().includes('severityname')){
        dataGridColors = {
            color: checkSeverityId(data, ALARM_SEVERITY.URGENT) ? '#FFFFFF' : '#000000',
            backgroundColor: '#' + severityColor
        }
        return dataGridColors
    }

    return dataGridColors
}

export const handleOnColorWithPill = (data: any, columnItem: any, theme?:any): ADataGridColors => {
    const severityColor = (data as { severityColor: string }).severityColor
    const colorTheme = theme?.palette?.mode === 'light' ? '#000000' : '#fff'
    const isNotFinalizedAlarm =
        data?.clearDate === "" ||
        data?.clearDate === null ||
        data?.clearDate === undefined
    const isStartOrFinalizedColumn = typeof columnItem.name === 'string' && (columnItem.name.toLowerCase().includes("datetime") || columnItem.name.toLowerCase().includes("cleardate"))
    let dataGridColors: ADataGridColors = {
        color: theme ? colorTheme : '#000000',
        backgroundColor: '',
    }

    if (isTeleObjectAlarmInhibited(data)) {
        return {
            color: '#FFFFFF',
            backgroundColor: INHIBITED_ALARM_COLOR,
        };
    }
    if(checkSeverityId(data, ALARM_SEVERITY.NOT_APPLICABLE)){
        return dataGridColors
    }
    if(isNotFinalizedAlarm && isStartOrFinalizedColumn) {
        dataGridColors = {
            color: checkSeverityId(data, ALARM_SEVERITY.URGENT) ? '#FFFFFF' : '#000000',
            backgroundColor: '#' + severityColor
        }
        return dataGridColors
    }

    return dataGridColors
}

export const mergeFiltersWithTotalizerAndPowerStation = (
    sidebarFilters: ADataGridFilter[],
    totalizer: TotalizerType,
    powerStationId: number
): ADataGridFilter[] => {
    // Remove filtros anteriores de totalizer e powerStationId para evitar duplicatas
    const baseFilters = sidebarFilters.filter(
        f => f.name !== 'totalizerType' && f.name !== 'powerStationId'
    );

    baseFilters.push({
        name: 'powerStationId',
        condition: 'equals',
        value: powerStationId.toString(),
        sort: 'none'
    });

    if (totalizer !== 'none') {
        baseFilters.push({
            name: 'totalizerType',
            condition: 'equals',
            value: totalizer,
            sort: 'none'
        });
    }

    return baseFilters;
};
